export default __webpack_public_path__ + "static/media/layout-banner.2edeef29.svg";